import _ from 'lodash';
import { del, get, patch, post } from './agent';
import { QueryString } from '~/utils';

const billing = {
  workspace: (workspacesUrl) => {
    const url = _([workspacesUrl, 'billing']).compact().join('/');
    return {
      get: () => get(url),
      getEvents: (query = {}) => get(url.concat('/events').concat(new QueryString(query).toString(true))),
      getInvoices: () => get(url.concat('/invoices')),
      create: () => post(url),
      updateContact: (body) => patch(url.concat('/contact'), body),
      updatePaymentMethod: (body) => patch(url.concat('/payment-method'), body),
      deletePaymentMethod: () => del(url.concat('/payment-method')),
      updatePlan: (body) => patch(url.concat('/plan'), body),
      cancelSubscription: () => del(url.concat('/subscription')),
      undoCancelSubscription: () => patch(url.concat('/subscription')),
    };
  },
};

export default billing;
